import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  House, ArrowsLeftRight, ChartLine, Calculator, CreditCard,
  Target, Sparkle, Bank, Handshake, ChartBar, Buildings
} from '@phosphor-icons/react';

const navItems = [
  { path: '/dashboard', label: 'Dashboard', icon: House },
  { path: '/transactions', label: 'Transactions', icon: ArrowsLeftRight },
  { path: '/stocks', label: 'NEPSE Stocks', icon: ChartLine },
  { path: '/banks', label: 'Accounts', icon: Bank },
  { path: '/lendborrow', label: 'Lend / Borrow', icon: Handshake },
  { path: '/emi', label: 'EMI Calculator', icon: Calculator },
  { path: '/payments', label: 'Payments', icon: CreditCard },
  { path: '/budgets', label: 'Budgets', icon: Target },
  { path: '/properties', label: 'Properties', icon: Buildings },
  { path: '/reports', label: 'Reports', icon: ChartBar },
  { path: '/ai-advisor', label: 'AI Advisor', icon: Sparkle },
];

export default function Sidebar({ alertCount = 0, mobileOpen = false, setMobileOpen }) {
  const location = useLocation();

  const NavContent = () => (
    <div className="flex flex-col h-full px-3 py-5">
      <div className="px-3 pb-4">
        <p className="text-[11px] font-bold uppercase tracking-[0.22em] text-[#7A766E]">Navigation</p>
      </div>
      <nav className="flex-1 space-y-2 overflow-y-auto">
        {navItems.map((item) => {
          const active = location.pathname === item.path;
          const Icon = item.icon;
          return (
            <Link
              key={item.path}
              to={item.path}
              onClick={() => setMobileOpen(false)}
              data-testid={`nav-${item.label.toLowerCase().replace(/[\s\/]/g, '-')}`}
              className={`flex items-center gap-3 px-4 py-3 rounded-2xl text-[15px] font-semibold transition-all duration-200 ${active ? 'bg-[#1E3F2D] text-white shadow-sm' : 'text-[#5C5A56] hover:bg-white hover:text-[#1C1B1A] hover:shadow-sm'}`}
            >
              <Icon size={20} weight={active ? 'fill' : 'regular'} />
              <span>{item.label}</span>
              {item.label === 'Alerts' && alertCount > 0 && (
                <span className={`ml-auto text-xs font-bold px-2 py-0.5 rounded-full ${active ? 'bg-white/20 text-white' : 'bg-[#A63C24] text-white'}`}>
                  {alertCount}
                </span>
              )}
            </Link>
          );
        })}
      </nav>
    </div>
  );

  return (
    <>
      {mobileOpen && <div className="lg:hidden fixed inset-0 bg-black/20 z-40" onClick={() => setMobileOpen(false)} />}
      <aside className="hidden lg:flex flex-col w-72 bg-[#F4F0EA] border-r border-[#E8E6E1] fixed left-0 top-[72px] h-[calc(100vh-72px)] z-30" data-testid="sidebar">
        <NavContent />
      </aside>
      <aside className={`lg:hidden flex flex-col w-80 bg-[#F4F0EA] border-r border-[#E8E6E1] fixed left-0 top-[72px] h-[calc(100vh-72px)] z-50 transform transition-transform duration-300 ${mobileOpen ? 'translate-x-0' : '-translate-x-full'}`}>
        <NavContent />
      </aside>
    </>
  );
}
